<template>
	<section id="content-sahabat" class="vx-row m-0 justify-center w-full bg-warning pb-24">
		<div class="vx-col w-full md:w-5/6 ">
			<vx-card style="margin-top: -6rem;" class="p-4">
				<sahabat-zx-data @changeData="changeData" :mitra="mitra" :totalPagination="totalPagination" />
			</vx-card>
		</div>
	</section>
</template>
<script>
	import SahabatZxData from './components/SahabatZXData.vue'
	export default {
		components: {
			SahabatZxData
		},
		data: () => ({
			params: {
				length: 12,
				start: 0,
				status: 1
			},
			mitra: [],
			totalPagination: 0
		}),
		methods: {
			changeData(ind) {
				const start = (ind - 1) * this.params.length
				const params = {
					length: this.params.length,
					start,
					status: 1
				}

				this.params = params

				this.getMitra()
			},
			getMitra() {
				this.$vs.loading()

				this.$store.dispatch('mitra/getChoiceMitra', this.params)
				.then(data => {
					const mitra = data.data.slice()
					this.$vs.loading.close()
					this.mitra = mitra
					this.totalPagination = Math.ceil( parseInt(data.recordsTotal) / this.params.length )
				})
				.catch(e => {
					console.error(e)
					this.$vs.loading.close()
					if(e.response) {
						console.error(e.response)
						this.$vs.notify({
							title: 'Oops',
							text: e.response.data.message,
							color: 'warning',
							position: 'top-right'
						})
					}

					return false
				})
			}
		},
		created() {
			this.getMitra()
		}
	}
</script>